import { render, staticRenderFns } from "./Documentacao.vue?vue&type=template&id=78a9f920"
import script from "./Documentacao.vue?vue&type=script&lang=js"
export * from "./Documentacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports